import * as types from './types'
import { api as config } from '../../config'
import Api from './Api'
export { types, Api }

export default new Api(config)
